import { render } from "./editIndustry.vue?vue&type=template&id=528de658&scoped=true"
import script from "./editIndustry.vue?vue&type=script&lang=js"
export * from "./editIndustry.vue?vue&type=script&lang=js"

import "./editIndustry.vue?vue&type=style&index=0&id=528de658&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528de658"],['__file',"src/views/brandProduct/components/editIndustry.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "528de658"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('528de658', __exports__)) {
    console.log('reload')
    api.reload('528de658', __exports__)
  }
  
  module.hot.accept("./editIndustry.vue?vue&type=template&id=528de658&scoped=true", () => {
    console.log('re-render')
    api.rerender('528de658', render)
  })

}


export default __exports__